<template>
  <DialogWindow
    ref="shareDialog"
    :title="$t('share.sharedesign')"
    @close="close"
  >
    <div v-if="linkToComposition">
      <text-input
        :readonly="true"
        :value="linkToComposition"
        @click.native="copyLink"
      />
    </div>
    <p v-else><base-icon name="loading"></base-icon></p>
    <base-button
      :disabled="linkToComposition === null"
      @click.native="copyLink"
    >
      {{ $t('share.copy.copy') }}
    </base-button>
  </DialogWindow>
</template>

<script>
import TextInput from './input/TextInput.vue';
import copyToClipboard from '../mixins/copyToClipboard';
import { ACTION_AWAIT_REQUEST } from '@/store/action-types';
import { CREATOR_API } from '../api/creator-api';
import { GETTER_COMPOSITION_COMPOSITION } from '../store/modules/composition/getters';
import DialogWindow from './DialogWindow.vue';
export default {
  name: 'ShareModal',
  components: {
    DialogWindow,
    TextInput
  },
  mixins: [copyToClipboard],
  data: () => ({
    linkToComposition: null
  }),
  methods: {
    close() {
      this.linkToComposition = null;
    },
    async share() {
      this.$refs.shareDialog.open();
      const composition = this.$store.getters[GETTER_COMPOSITION_COMPOSITION];
      this.show = true;
      await this.$store.dispatch(ACTION_AWAIT_REQUEST, async () => {
        try {
          this.linkToComposition = await CREATOR_API.share.create(
            this.$route.params.articleNumber,
            composition
          );
        } catch (err) {
          this.$toasted.error(this.$t('share.sharefail'), { duration: 5000 });
          this.close();
        }
      });
    },
    async copyLink() {
      if (await this.copyToClipboard(this.linkToComposition)) {
        this.$toasted.success(this.$t('share.copy.success'), {
          duration: 5000
        });
      } else {
        this.$toasted.error(this.$t('share.copy.fail'), { duration: 8000 });
      }
    }
  }
};
</script>

<style scoped>
div[role='dialog'] {
  @apply border rounded-lg shadow-lg p-5 fixed bg-white z-50;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@screen xs {
  div[role='dialog'] {
    /* min-width: 90%; */
    /* transform: translateX(-50%); */
  }
}

div.open[role='dialog'] {
  animation: fadein 250ms ease-in-out forwards;
}

button:first-child {
  @apply absolute pin-r mr-3;
}

button:last-child {
  @apply w-full h-full;
}

input {
  @apply w-full mb-2 cursor-pointer;
}

h3 {
  @apply text-3xl my-2 pb-2;
}

p {
  @apply text-2xl my-2 pb-2 flex content-center justify-center;
}
</style>
